// extracted by mini-css-extract-plugin
export default {"selector_main":"ModalSelector_selector_main__XL3UK"};